import React from 'react';
import GoogleMap from 'google-map-react';
import Loader from 'components/layout/Loader';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';

import AbstractCmsElement from 'components/cms/elements/AbstractCmsElementNew';

import * as constants from 'js/constants';
class CmsElementMap extends AbstractCmsElement {
  constructor(props) {
    super(props);

    this.allowStateChange = true;

    this.state = {
      shown: false,
    };
  }

  shown = () => {
    if (this.allowStateChange) {
      this.setState({ shown: true });
    }
  };

  render() {
    const { appIntl } = this.props;
    const { shown } = this.state;

    /* Before the update there was a scriptloader for GoogleMaps here.
    This was removed for compatibility reasons... no alternative yet */

    const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';

    const position = {
      lat: parseFloat(this.getParamValue('mapLat', 49.4456943)),
      lng: parseFloat(this.getParamValue('mapLng', 7.7704389)),
    };

    const parallaxData = this.getParallaxData();
    // try react-lazy.. still not tested


    const innerContent = (
      <div
        id={this.getMainId()}
        className={'ms-map ' + shownClass + this.getResponsiveClasses() + this.getCssClasses()}
        style={{ ...this.getBackgroundStyle(), height: this.getParamValue('mapHeight', 300) + 'px' }}
      >
        {this.getElementStyle()}
        <GoogleMap
          bootstrapURLKeys={{
            key: constants.GOOGLE_MAPS_KEY,
            language: appIntl.locale,
            libraries: ['places'],
          }}
          defaultCenter={position}
          defaultZoom={this.getParamValue('mapZoom', 11)}
          options={constants.mapOptions}
        />
        {this.getAppendHtml()}
      </div>
    );

    return (
      <CustomScrollTrigger className="cms-overflow-fix" onEnter={this.shown} {...this.getCustomId()}>
        {parallaxData ? (
          <Parallax {...parallaxData}>
            {innerContent}
          </Parallax>
        ) : (
          innerContent
        )}
      </CustomScrollTrigger>

    );
  }
}
CmsElementMap.defaultProps = {
  index: '0',
};

//export default scriptLoader(constants.GOOGLE_MAPS_URL)(CmsElementMap);
export default CmsElementMap;
